module.exports = __webpack_public_path__ + "static/media/image-mobile.1242cf78.png";